/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
  Facebook,
  Linkedin,
  WhatsApp,
} from "vue-socialmedia-share";

import {
  mapGetters
} from 'vuex';

export default {
  name: 'public-blog-details',
  components: {
  Facebook,
  Linkedin,
  WhatsApp,
  },
  props: [],
  data () {
    return {
      singleBlogDetails:null,
      url:'',
      publicBlogListState:{},
      publicBlogListResults:[],
      suggestionBlogId:''
    }
  },
  computed: {
    ...mapGetters([
      'publicSingleBlogDetailsByIdGetters',
      'suggestionBlogListGetters',
    ]),
    getBlogDetailsAgainFun(){
      this.singleBlogDetails = this.$store.getters.publicSingleBlogDetailsByIdGetters.response
      return
    },
    getPubBlogListFun(){
      this.publicBlogListState = this.$store.getters.suggestionBlogListGetters.data
      return
    },
    setInitialPubBlogStates(){
      if(this.publicBlogListState != undefined){
        this.publicBlogListResults = this.publicBlogListState.results
      }
    },
  },
  mounted () {
    this.suggestionBlogId = this.$route.params.pubBlogId
    this.getBlogDetailsAgainFun
    this.url = window.location.href
    this.getPubBlogListFun
    this.setInitialPubBlogStates
  },
  created () {
    document.addEventListener('scroll', this.updateScrollBar);
    window.addEventListener('resize', this.updateScrollBar);
  },
  destroyed () {
    document.removeEventListener('scroll', this.updateScrollBar);
    window.removeEventListener('resize', this.updateScrollBar);
  },
  methods: {
    updateScrollBar() {
      var doc = document.documentElement;
      var win = window;
      var scrollTop = (doc && doc.scrollTop) || (document.body && document.body.scrollTop);
      var scrollHeight = (doc && doc.scrollHeight) || (document.body && document.body.scrollHeight);
      var clientHeight = doc ? doc.clientHeight : document.body.clientHeight;
      var scrollPercent = scrollTop / (scrollHeight - clientHeight) * 100;
      var scrollBar = document.getElementById('scroll-bar');
      scrollBar.style.width = scrollPercent + '%';
    },
    changeSuggestionBlogDetailsFun(blogId){
      this.suggestionBlogId = blogId
      if(blogId != this.$route.params.pubBlogId){
        this.$router.push({ name: 'pubBlogDetail', params: { pubBlogId: blogId } })
        this.blogLoader = true
        this.$store.dispatch('getPublicBlogDetailsByIdAction',{id:blogId}).then((res)=>{
          this.singleBlogDetails = res.data.data.response
          this.blogLoader = false
        }).catch((err)=>{
          this.blogLoader = false
        })
      }
    }
  },
  watch:{
    getBlogDetailsAgainFun(){
      return this.$store.getters.publicSingleBlogDetailsByIdGetters
    },
    getPubBlogListFun(){
      return this.$store.getters.suggestionBlogListGetters
    },
    setInitialPubBlogStates(){
      if(this.publicBlogListState != undefined){
        this.publicBlogListResults = this.publicBlogListState.results
      }
    },
  },
  beforeCreate: function() {
    $('body').addClass('dashboard')
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('dashboard')
    next();
  },
}